
	import {
		Component,
		Vue,
		Prop,
		Watch,
		Emit,
		Mixins
	} from "vue-property-decorator";
	import VuePerfectScrollbar from "vue-perfect-scrollbar";
	import vSelect from "vue-select"; // @ref https://sagalbot.github.io/vue-select/
	import draggable from "vuedraggable";
	import { namespace } from "vuex-class";
	import { parseTaskText } from "@/filters";
	import api from "../../services/api.service";
	import { TaskLibrary } from '@/store/tasks/types';

	const Tasks = namespace("tasks");

	@Component({
		components: {
			VuePerfectScrollbar,
			draggable,
			"v-select": vSelect,
			"subaction-modal": () => import("../tasks/AddSubAction.vue")
		},
		filters: {
			parseTaskText
		}
	})
	export default class TaskTriggerDialog extends Vue {
		@Tasks.Getter("getTaskTypes") taskTypes: any; // fetched automatically by initApp action
		@Tasks.Getter("getEditTriggerAction") triggerAction: any;
		@Tasks.Getter getActionById: (actionId: number) => TaskLibrary;
		@Tasks.Mutation setEditTriggerAction: any;
		@Tasks.State(state => state.TaskLibrary) taskLibrary: TaskLibrary[];
		@Tasks.Action loadEditTriggerAction: (action:any) => Promise<void>;

		@Prop({ type: Boolean, default: false }) showTaskTriggerModal: boolean;

		private yesNoOptions: any[] = ["Yes", "No"];
		private taskList: any[] = [];
		private error: string = null;
		private showSubActionModal: boolean = false;

		private get taskTypesByTitle(): any {
			let taskTypes: any = {};
			this.taskTypes.forEach(type => {
				taskTypes[type.taskTypeID] = type.title;
			});
			return taskTypes;
		}

		// Removes the trigger (dependant task) from the array of triggers
		private removeTrigger(trigger): void {
			let triggerIndex = this.triggerAction.trigger.indexOf(trigger);
			this.triggerAction.trigger.splice(triggerIndex, 1);
		}

		// Saves the Trigger tasks
		// N.B. Any new subactions added are automatically saved when they are added
		private async save(): Promise<void> {
			this.triggerAction.trigger.forEach(element => {
				element.trigger.taskData = JSON.stringify(element.trigger.taskData);
			});
			await api.triggeredTasksSave(
				this.triggerAction.taskID,
				this.triggerAction.trigger
			);
			this.triggerAction.triggeredTaskCount = this.triggerAction.trigger.length;

			this.setEditTriggerAction(null);
			this.$emit('close-trigger-action-dialog');
		}

		// Handles the closure of the TaskTrigger Dialog
		private cancel(): void {
			this.setEditTriggerAction(null);
			this.$emit('close-trigger-action-dialog');
		}

		// Opens the sub / child action modal
		private openSubActionModal(): void {
			this.showSubActionModal = true;
		}

		// Refetches the trigger action data as state is not updated
		private async refreshTriggerActions(): Promise<void> {
            const action: TaskLibrary = this.taskLibrary.find((a: TaskLibrary) => a.taskID === this.triggerAction.taskID);
            await this.loadEditTriggerAction(action);
        }

		// Forces the refresh of the data in the TaskTrigger dialog and
		// Closes the sub / child action modal
		private async closeSubActionModal(): Promise<void> {
			await this.refreshTriggerActions();
			this.showSubActionModal = false;
        }
	}
